import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import useStyles from "./ScoresStyle";

const IconeEvolutionScore = ({isRiskLower, riskStyle}) => {
    const { classes } = useStyles();

      if(isRiskLower === null) return(<></>);
  
      return (
        <span className={classes.iconeRiskEvolution} style={{backgroundColor: riskStyle.mainColor}}>
          {isRiskLower ? 
           <ArrowDownward style={{color: "#FFF", fontSize: "20px"}} />
          :
           <ArrowUpward style={{color: "#FFF", fontSize: "20px"}}/>
        }
        </span>
      )
    
  }

export default IconeEvolutionScore;